<p-fieldset legend="Pré-qualificação">
  <div class="row">
    <label class="required col-3 col-form-label">
      Houve fase de pré-qualificação?
    </label>
    <p-selectButton [options]="opcoesSimNao" optionValue="id" class="col-3" [(ngModel)]="entidade.PreQualificacaoNao"
      [ngModelOptions]="{standalone: true}">
      <ng-template let-opcao>
        <span class="p-1" style="font-size: 0.8rem;">{{opcao.nome}}</span>
      </ng-template>
    </p-selectButton>
  </div>
</p-fieldset>